import FornecedorIndustriaForm from '../../../produto/spa/fornecedor/industria/FornecedorIndustriaForm';

export default FornecedorIndustriaForm;
